const BILLING_ENUMS = {
  MODAL_CLOSE: -1,
  UPDATE_PAYMENT_METHOD: 7,
};

export default BILLING_ENUMS;
